import React from 'react';

import {Loader} from '../../lib/loader/loader';
import {useBookingMachine} from '../../hooks/useBookingMachine';

import {AvailabilityEmpty} from '../../lib/availability-empty/availability-empty';
import {BookingWeekDayPicker} from '../booking-week-day-picker/booking-week-day-picker';
import {BookingTimeslotPicker} from '../booking-timeslot-picker/booking-timeslot-picker';
import {BookingNotifyHostButton} from '../booking-notify-host-button/booking-notify-host-button';
import {BookingAvailabilityError} from '../booking-errors/booking-availability-error';
import {BookingNavigationButtons} from '../booking-navigation-buttons/booking-navigation-buttons';

import css from './booking-date-time-picker.css';


export const BookingDateTimePicker = () => {
  const {bookingState} = useBookingMachine();

  const isAvailabilityLoading = bookingState.matches({
    dateTimePicker: 'availabilityLoading',
  });
  const isAvailabilityNotifyHost = bookingState.matches({
    dateTimePicker: 'availabilityNotify',
  });
  const isAvailabilitySlots = bookingState.matches({
    dateTimePicker: 'availabilitySlots',
  });
  const isAvailabilityEmpty = bookingState.matches({
    dateTimePicker: 'availabilityEmpty',
  });
  const isTimeslotConfirmation = bookingState.matches({
    dateTimePicker: 'timeslotConfirmation',
  });
  const isRescheduleReasonForm = bookingState.matches('rescheduleForm');
  const hasAvailabilityError = bookingState.matches({
    dateTimePicker: 'availabilityError',
  });

  const showBookingTimeslotPicker =
    isAvailabilitySlots || isTimeslotConfirmation || isRescheduleReasonForm;

  const showBookingWeekDayPicker = !isAvailabilityNotifyHost;

  return (
    <div className={css.bookingDateTimePicker}>
      {showBookingWeekDayPicker && <BookingWeekDayPicker />}
      {isAvailabilityLoading && <Loader />}
      {showBookingTimeslotPicker && <BookingTimeslotPicker />}
      {hasAvailabilityError && <BookingAvailabilityError />}
      {isAvailabilityEmpty && <AvailabilityEmpty />}
      {isAvailabilityNotifyHost && <BookingNotifyHostButton />}
      {showBookingWeekDayPicker && <BookingNavigationButtons />}
    </div>
  );
};
